/**
 * @generated SignedSource<<7653b8aaeac5b68f462d3fdb740d05d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookTypeEnum = "normal" | "school" | "%future added value";
export type BookCreateInput = {
  coverPdf: Upload;
  description?: string | null;
  edition: string;
  problemPdf: Upload;
  publisher: string;
  solutionPdf: Upload;
  title: string;
  type: BookTypeEnum;
  unitAs: ReadonlyArray<string>;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type BookCreateDialog_bookCreateMutation$variables = {
  input: BookCreateInput;
};
export type BookCreateDialog_bookCreateMutation$data = {
  readonly bookCreate: {
    readonly id: string;
  };
};
export type BookCreateDialog_bookCreateMutation = {
  response: BookCreateDialog_bookCreateMutation$data;
  variables: BookCreateDialog_bookCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Book",
    "kind": "LinkedField",
    "name": "bookCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookCreateDialog_bookCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookCreateDialog_bookCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4cc0a34a0b06ba84743003274c0c86f0",
    "id": null,
    "metadata": {},
    "name": "BookCreateDialog_bookCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BookCreateDialog_bookCreateMutation(\n  $input: BookCreateInput!\n) {\n  bookCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8da935a07a0d8a9e5609bf59db1df395";

export default node;
